import './css/generic.css'
import './css/vars.css'
import './css/animate.min.css'
import './css/utilityclasses.css'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
Bugsnag.start({
  apiKey: 'e80bd02fc3afe0e8214e98bd7a3cc6ee',
  plugins: [new BugsnagPluginVue()],
  appVersion: '7.11.0',
  user: {
    id: store.state.loggedInUserInfo != null ? store.state.loggedInUserInfo.id : '',
    name: store.state.loggedInUserInfo != null ? store.state.loggedInUserInfo.firstname + ' ' + store.state.loggedInUserInfo.lastname : '',
    email: store.state.loggedInUserInfo != null ? store.state.loggedInUserInfo.email : '',
  }
})
const bugsnagVue = Bugsnag.getPlugin('vue')

Vue.config.productionTip = false

/**
 * Add some generic helper functions as a mixin to the root instance.
 * https://vuejs.org/v2/guide/mixins.html
 */

import helpers from './mixins/helpers';

/**
 * Fire up the app!
 */
new Vue({
  // add some generic helper functions which we can call like this: this.$root.xyz()
  mixins: [helpers],
  /**
   * Add components that will inherit down to all child
   * components, and be accessible like this.$store
   * for example.
   */
  router,
  store,
  render: h => h(App)
}).$mount('#app')

bugsnagVue.installVueErrorHandler(Vue)
